'use client';

import dynamic from 'next/dynamic';
import { RectangleSkeleton } from '@fe-common-ui/Skeleton';

const DynamicPopTopicGroupTagsGroup = dynamic(() => import('./PopTopicGroupTagsGroup'), {
  ssr: false,
  loading: () => <RectangleSkeleton width={44} height={24} />
});

export default DynamicPopTopicGroupTagsGroup;
